import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SellerRatingReviewsService {

    constructor(private _http: HttpClient) { }

    getsellerreviews(data) {
        return this._http.post(environment.api_url+'seller/rating/list',data);
    }

}
